package pl.mothdigital.neuronowi.components.sections.footer

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

@Composable
fun FooterTopSection() {
    // region Small Screen
    Column(
        modifier = Modifier.maxWidth(80.cssRem).displayUntil(Breakpoint.MD),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        FooterLogoImage()
        VerticalSpacer(1.cssRem)
        FooterTitleAndDescription(
            horizontalAlignment = Alignment.CenterHorizontally,
            titleModifier = Modifier,
            descriptionModifier = Modifier.maxWidth(22.cssRem).textAlign(TextAlign.Justify),
        )
        VerticalSpacer(2.cssRem)
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy((0.3).cssRem),
        ) {
            SpanText(
                text = "Informacje kontaktowe",
                modifier = NoWrapTextStyle.toModifier()
                    .fillMaxWidth()
                    .textAlign(TextAlign.Center)
                    .fontWeight(FontWeight.Medium)
                    .fontSize(1.cssRem)
                    .color(SiteTheme.white._900)
            )
            Column(modifier = Modifier.widthIn(min = 20.cssRem, max = 30.cssRem)) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(right = (1.5).cssRem).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaMapLocation()
                    HorizontalSpacer((0.7).cssRem)
                    SpanText(
                        text = "Fabryczna 17a/1, 65-410 Zielona Góra",
                        modifier = NoWrapTextStyle.toModifier()
                            .weight(1f)
                            .textAlign(TextAlign.Center)
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth().padding(right = (1.5).cssRem),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaEnvelope()
                    HorizontalSpacer((0.8).cssRem)
                    SpanText(
                        text = "neuronowi.zg@gmail.com",
                        modifier = NoWrapTextStyle.toModifier()
                            .weight(1f)
                            .textAlign(TextAlign.Center)
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth().padding(right = (1.5).cssRem),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaSquarePhone()
                    HorizontalSpacer((0.8).cssRem)
                    SpanText(
                        text = "+48 500 124 500",
                        modifier = NoWrapTextStyle.toModifier()
                            .weight(1f)
                            .textAlign(TextAlign.Center)
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth().padding(right = (1.5).cssRem),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaSquarePhone()
                    HorizontalSpacer((0.8).cssRem)
                    SpanText(
                        text = "+48 600 234 002",
                        modifier = NoWrapTextStyle.toModifier()
                            .weight(1f)
                            .textAlign(TextAlign.Center)
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
            }
        }
        VerticalSpacer(1.cssRem)
        FooterMediaButtons()
    }
    // endregion

    // region Large Screen
    Row(
        modifier = Modifier.fillMaxWidth().displayIfAtLeast(Breakpoint.MD),
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.Center,
    ) {
        Spacer()
        FooterLogoImage()
        HorizontalSpacer(1.cssRem)
        Column(Modifier.padding(1.cssRem).maxWidth(24.cssRem)) {
            FooterTitleAndDescription(horizontalAlignment = Alignment.Start)
            VerticalSpacer(1.cssRem)
            FooterMediaButtons()
        }
        Spacer()
        Spacer()
        Column(
            modifier = Modifier.padding(topBottom = 1.cssRem),
            verticalArrangement = Arrangement.spacedBy((0.4).cssRem),
        ) {
            SpanText(
                text = "Informacje kontaktowe",
                modifier = NoWrapTextStyle.toModifier()
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .fontWeight(FontWeight.Medium)
                    .fontSize(1.cssRem)
                    .color(SiteTheme.white._900)
            )
            Column(modifier = Modifier) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaMapLocation()
                    HorizontalSpacer((0.7).cssRem)
                    SpanText(
                        text = "Fabryczna 17a/1, 65-410 Zielona Góra",
                        modifier = NoWrapTextStyle.toModifier()
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaEnvelope()
                    HorizontalSpacer((0.8).cssRem)
                    SpanText(
                        text = "neuronowi.zg@gmail.com",
                        modifier = NoWrapTextStyle.toModifier()
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaSquarePhone()
                    HorizontalSpacer((0.8).cssRem)
                    SpanText(
                        text = "+48 500 124 500",
                        modifier = NoWrapTextStyle.toModifier()
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    FaSquarePhone()
                    HorizontalSpacer((0.8).cssRem)
                    SpanText(
                        text = "+48 600 234 002",
                        modifier = NoWrapTextStyle.toModifier()
                            .fontWeight(FontWeight.Normal)
                            .fontSize(0.7.cssRem)
                            .color(SiteTheme.white._900)
                    )
                }
            }
        }
        Spacer()
        Spacer()
    }
    // endregion
}

@Composable
fun FooterTitleAndDescription(
    modifier: Modifier = Modifier,
    horizontalAlignment: Alignment.Horizontal = Alignment.CenterHorizontally,
    titleModifier: Modifier = Modifier,
    descriptionModifier: Modifier = Modifier,
) {
    AppH1 {
        Column(
            modifier = modifier,
            horizontalAlignment = horizontalAlignment,
        ) {
            SpanText(
                text = FooterResources.FOOTER_TITLE,
                modifier = Modifier
                    .fontWeight(FontWeight.Medium)
                    .fontSize(1.cssRem)
                    .lineHeight(1.5.cssRem)
                    .color(SiteTheme.white._900)
                    .then(titleModifier),
            )
            VerticalSpacer((0.1).cssRem)
            SpanText(
                text = FooterResources.H1_DESCRIPTION,
                modifier = Modifier
                    .fontWeight(FontWeight.Normal)
                    .fontSize(0.7.cssRem)
                    .lineHeight(1.cssRem)
                    .color(SiteTheme.white._900)
                    .then(descriptionModifier),
            )
        }
    }
}
